import Carousel from "../../components/Carousel";
import Footer from "../../components/Footer";
import "./styles.scss";
import { DENIM_HERO_TEXT, DENIM_HERO_SUBTEXT, FEATURED_MILLS, TESTIMONIALS } from "./constants";
import QueryHeroSection from "../../components/QueryForm/HeroSection";
import FeaturedDenimMills from "../../components/QueryForm/FeaturedDenimMills";
import LocofastInNews from "../../components/QueryForm/LocofastInNews";
import QueryForm from "../../components/QueryForm/GenericQueryForm";

const DenimPage = () => {
    return(
        <div className="denim_page_container">
        <QueryHeroSection text={DENIM_HERO_TEXT} subText={DENIM_HERO_SUBTEXT}/>
        <QueryForm />
        <FeaturedDenimMills featuredMills={FEATURED_MILLS} />
        <LocofastInNews />
        <Carousel heading="Best service begins here"  isHomePage={true} testimonials={TESTIMONIALS} isProductsPage={true} showRadioButton={true}/>
        <Footer />
        </div>
    )
}

export default DenimPage;